{
  "previous": "ਪਿਛਲਾ",
  "next": "ਅਗਲਾ",
  "complete": "ਪੂਰਾ ਕਰੋ",
  "verifyAndCheckIn": "ਤਸਦੀਕ ਕਰੋ ਅਤੇ ਚੈੱਕ-ਇਨ ਕਰੋ",
  "loading": {
    "retrievingLocation": "ਟਿਕਾਣਾ ਪ੍ਰਾਪਤ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "retrievingWarehouse": "ਗੁਦਾਮ ਦਾ ਡਾਟਾ ਪ੍ਰਾਪਤ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ..."
  },
  "validation": {
    "fieldRequired": "ਇਹ ਖੇਤਰ ਲਾਜ਼ਮੀ ਹੈ",
    "fieldRequiredWithLabel": "{label} ਲਾਜ਼ਮੀ ਹੈ",
    "phoneInvalid": "ਇਹ ਇੱਕ ਵੈਧ ਫ਼ੋਨ ਨੰਬਰ ਨਹੀਂ ਹੈ",
    "phoneInvalidWithExample": "ਇਹ ਇੱਕ ਵੈਧ ਫ਼ੋਨ ਨੰਬਰ ਨਹੀਂ ਹੈ (ਉਦਾਹਰਨ: {example})"
  }
}
